import { Chart } from "chart.js"

// Global Chart.js (v2.9.4) configuration
// This sets defaults for all charts across the application

// Get the current color from CSS variables
function getDefaultTextColor() {
  const color = getComputedStyle(document.body).getPropertyValue('--color-secondary-text').trim()
  return color || '#999999' // Fallback if CSS variable not found
}

// Update Chart.js global colors based on current theme
export function updateChartColors() {
  const textColor = getDefaultTextColor()

  Chart.defaults.global.defaultFontColor = textColor

  // Additional color options for reference
  // Chart.defaults.global.legend.labels.fontColor = textColor
  // Chart.defaults.global.tooltips.titleFontColor = textColor
  // Chart.defaults.global.tooltips.bodyFontColor = textColor
}

// Update colors on every Turbo visit (re-reads CSS variables after navigation)
document.addEventListener('turbo:load', updateChartColors)

// Listen for dark mode changes and update existing charts
window.addEventListener('dark-mode-changed', () => {
  updateChartColors()

  // Update all existing chart instances
  Object.values(Chart.instances).forEach(chart => {
    if (chart && chart.update) {
      chart.update()
    }
  })
})

export default Chart
